import TrainingRegistrationCard from './TrainingRegistrationCard.vue';

export default TrainingRegistrationCard;
